import { DailyDataType } from "../types/Calendar";
import { convertPersianNumberToEnglish } from "./JavascriptHelpers";

export const dayInMilliseconds = 24 * 60 * 60 * 1000;

export function diffInDays(date1: Date, date2: Date) {
    return Math.abs(date1.getTime() - date2.getTime()) / dayInMilliseconds;
}

export function getDayInMonth(date = new Date()) {
    return new Intl.DateTimeFormat('fa-IR', {day: '2-digit'}).format(date)
} 

export function getMonth(date = new Date()) {
    return new Intl.DateTimeFormat('fa-IR', {month: 'short'}).format(date)
}

export function getDayIndex(date = new Date()) {
    const weekDays = ['شنبه', 'یکشنبه', 'دوشنبه', 'سه‌شنبه', 'چهارشنبه', 'پنجشنبه', 'جمعه']
    return weekDays.indexOf(new Intl.DateTimeFormat('fa-IR', {weekday: 'short'}).format(date)) 
}

export function getDayLabel(date = new Date()) {
    const weekDays = ['شنبه', 'یکشنبه', 'دوشنبه', 'سه‌شنبه', 'چهارشنبه', 'پنجشنبه', 'جمعه']
    return weekDays[weekDays.indexOf(new Intl.DateTimeFormat('fa-IR', {weekday: 'short'}).format(date))] 
}

export function getMonthIndex(date = new Date()) {
    return new Intl.DateTimeFormat('fa-IR', {month: 'numeric'}).format(date)
}

export function ISOStringWithTimeZone(date = new Date()) {
    return new Intl.DateTimeFormat('en-US', {year: 'numeric'}).format(date)
            + '-' + new Intl.DateTimeFormat('en-US', {month: '2-digit'}).format(date) 
            + '-' + new Intl.DateTimeFormat('en-US', {day: '2-digit'}).format(date);
}

export async function traverseDaysInterval(startDay: Date, endDay: Date, today: Date, getKeyFromDate: (date: Date, traverseIndex: number) => string) {
    let currentDate = new Date(startDay);
    const data = {} as DailyDataType;

    return new Promise((resolve) => {
        let traverseIndex = 0;
        while (currentDate <= endDay) {
            const uniqeKey = getKeyFromDate(currentDate, traverseIndex)
        
            const currentData = data[uniqeKey] || [];
            currentData.push({
                jalali: formatDate(currentDate), 
                simplifiedJalali: formatDate(currentDate, true),
                ISO: ISOStringWithTimeZone(currentDate),
                dayIndex: getDayIndex(currentDate),
                dayInMonth: convertPersianNumberToEnglish(getDayInMonth(currentDate)) as number,
                isToday: currentDate.getTime() === today.getTime(),
                isCurrentMonth: getMonth(currentDate) === getMonth(today) 
            })
    
            data[uniqeKey] = currentData;
            currentDate.setDate(currentDate.getDate() + 1);
            traverseIndex++;
        }
        
        resolve(data);
    })
}


export function formatDate(date = new Date(), simplify = false, minutesOffset = 0, containDayName = false, localeString = false) {
    const formattedDate = new Date(date.getTime() + minutesOffset * 60000);

    try {        
        if (localeString) {
            const locale = date.toLocaleString('fa-IR', { timeZone: 'Asia/Tehran' });
            return locale.substring(0, locale.indexOf(','));
        }

        if (simplify) {
            if (containDayName) 
                return new Intl.DateTimeFormat('fa-IR', {weekday: 'short'}).format(date) + ' ' +
                    convertPersianNumberToEnglish(new Intl.DateTimeFormat('fa-IR', {day: 'numeric'}).format(date)) + ' ' +
                    new Intl.DateTimeFormat('fa-IR', {month: 'short'}).format(date) + ' '
            else
                return convertPersianNumberToEnglish(new Intl.DateTimeFormat('fa-IR', {day: 'numeric'}).format(formattedDate)) + ' ' +
                    new Intl.DateTimeFormat('fa-IR', {month: 'short'}).format(formattedDate) + ' '
        } else
            return new Intl.DateTimeFormat('fa-IR', {weekday: 'short'}).format(formattedDate) + ' ' +
                new Intl.DateTimeFormat('fa-IR', {day: '2-digit'}).format(formattedDate) + ' ' +
                new Intl.DateTimeFormat('fa-IR', {month: 'short'}).format(formattedDate) + ' ' +
                new Intl.DateTimeFormat('fa-IR', {year: 'numeric'}).format(formattedDate)
    } catch (e) {
        return '';
    }
}

export function int_to_time(value: number | undefined, simplify: boolean = false) {
    if ((!value || isNaN(value)) && value !== 0)
        return ''

    const hour = Math.floor(value / 60).toString();
    const minute = (value % 60).toString();

    return (hour.length === 1 && !simplify ? '0' + hour : hour)
        + ":" +
        (minute.length === 1 && !simplify ? '0' + minute : minute);
}

export function extractTimeFromLabel(time: string) {
    const colonPosition = time?.indexOf(':') || 0;
    const hour = Number(time?.substring(0, colonPosition));
    const minute = Number(time?.substring(colonPosition + 1));
    const value = hour * 60 + minute;

    return {hour, minute, value}
}

export function twoDigitNumber(value: number) {
    const stringValue = value.toString();
    if (stringValue.length === 1)
        return '0' + stringValue;

    return stringValue;
}

export function extractTimeParts(value: number) {
    const hours = Math.floor(value / 3600);
    
    value -= hours * 3600;

    const minutes = Math.floor(value / 60);

    value -= minutes * 60;

    return { hours: twoDigitNumber(hours), minutes: twoDigitNumber(minutes), seconds: twoDigitNumber(value) }
}